module.exports = __webpack_public_path__ + "img/pdf.03d5088e.svg";